var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 6.66667C5.17428 6.66667 6.66667 5.17428 6.66667 3.33333C6.66667 1.49238 5.17428 0 3.33333 0C1.49238 0 0 1.49238 0 3.33333C0 5.17428 1.49238 6.66667 3.33333 6.66667ZM14.9998 6.66667C16.8408 6.66667 18.3332 5.17428 18.3332 3.33333C18.3332 1.49238 16.8408 0 14.9998 0C13.1589 0 11.6665 1.49238 11.6665 3.33333C11.6665 5.17428 13.1589 6.66667 14.9998 6.66667ZM18.3334 14.6663C18.3334 16.5073 16.841 17.9997 15.0001 17.9997C13.1591 17.9997 11.6667 16.5073 11.6667 14.6663C11.6667 12.8254 13.1591 11.333 15.0001 11.333C16.841 11.333 18.3334 12.8254 18.3334 14.6663ZM3.33333 17.9997C5.17428 17.9997 6.66667 16.5073 6.66667 14.6663C6.66667 12.8254 5.17428 11.333 3.33333 11.333C1.49238 11.333 0 12.8254 0 14.6663C0 16.5073 1.49238 17.9997 3.33333 17.9997Z",
    fill: "url(#paint0_linear_2312_5822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2312_5822",
    x1: -5.43454,
    y1: 21.828,
    x2: 21.9106,
    y2: 9.52894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185344,
    stopColor: "#5AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E757FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.98e2b35b713c0d5e51f1edc047265bc2.svg";
export { ForwardRef as ReactComponent };